<template>
  <div class="tab-container">
    <vue-dialog
      color="#b0d255"
      v-if="show_dialog"
      :name="data_name"
      :left="data_left"
      :right="data_right"
      :title="data_title"
      :value="data_value"
      :single="true"
      @dialog_end="dialogend"
    >
    </vue-dialog>
    <div class="position-title">{{ uppercase(pos_define_positions_title) }}</div>
    <div class="house-container">
      <img :src="pos_house.images[typ_house.value + '_1']" alt="key" />
    </div>
    <div class="house-container-description">
      {{ pos_description_title }}
    </div>
    <div
      v-for="value in get_ordered_construction_1"
      :key="'pozicija' + value.key"
      class="position-container"
      :style="{
        'background-color':
          pos_status.value[value.key].status == 1
            ? '#b0d255'
            : pos_status.value[value.key].potvrda
            ? '#82c964'
            : '#e6e7e8',
        color: pos_status.value[value.key].status == 0 && !pos_status.value[value.key].potvrda ? '#6d6e70' : '#ffffff',
      }"
      @click.stop="navigate_right(value.key)"
    >
      <div class="left">
        <img
          :src="require('../assets/images/konstrukcija/pozicije/' + ('' + value.key).padStart(2, '0') + '_icon.svg')"
          alt
        />
      </div>
      <div class="middle">{{ value.title }}</div>
      <div class="right">
        <img
          class="right"
          v-if="pos_status.value[value.key].status == 0 && !pos_status.value[value.key].potvrda"
          src="../assets/images/Strelica_svetlo_zelena_desno.svg"
          alt
        />
        <img
          v-if="pos_status.value[value.key].potvrda && pos_status.value[value.key].status == 0"
          class="again"
          src="../assets/images/Stikla.svg"
          alt
        />
        <div v-if="pos_status.value[value.key].status == 1">
          <img class="again left" src="../assets/images/stikla_dupla.svg" alt />
        </div>
      </div>
    </div>
    <div class="parameters" @click="toggle_position">
      <div class="inner left text">{{ status ? app_less_parameters_title : app_more_parameters_title }}</div>
      <div class="inner right">
        <svg v-if="status" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.255 10.28">
          <path
            style="fill: currentColor;"
            id="Strelica_Next"
            d="M1 21.3a1.854 1.854 0 0 1-.7-.2.972.972 0 0 1-.1-1.4l7.7-9-7.7-9A.966.966 0 0 1 .3.3a.972.972 0 0 1 1.4.1L10 10a1.051 1.051 0 0 1 0 1.3L1.8 21a1.135 1.135 0 0 1-.8.3z"
            class="cls-1"
            transform="rotate(-90 5.09 5.135)"
          />
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.255 10.28">
          <path
            style="fill: currentColor;"
            id="Strelica_Next"
            d="M1 21.3a1.854 1.854 0 0 1-.7-.2.972.972 0 0 1-.1-1.4l7.7-9-7.7-9A.966.966 0 0 1 .3.3a.972.972 0 0 1 1.4.1L10 10a1.051 1.051 0 0 1 0 1.3L1.8 21a1.135 1.135 0 0 1-.8.3z"
            class="cls-1"
            transform="rotate(90 10.623 10.678)"
          />
        </svg>
      </div>
    </div>
    <div ref="additional" class="additional">
      <div
        v-for="value in get_ordered_construction_2"
        :key="'pozicija' + value.key"
        class="position-container"
        :style="{
          'background-color':
            pos_status.value[value.key].status == 1
              ? '#b0d255'
              : pos_status.value[value.key].potvrda
              ? '#82c964'
              : '#e6e7e8',
          color:
            pos_status.value[value.key].status == 0 && !pos_status.value[value.key].potvrda ? '#6d6e70' : '#ffffff',
        }"
        @click.stop="navigate_right(value.key)"
      >
        <div class="left">
          <img
            :src="require('../assets/images/konstrukcija/pozicije/' + ('' + value.key).padStart(2, '0') + '_icon.svg')"
            alt
          />
        </div>
        <div class="middle">{{ value.title }}</div>
        <div class="right">
          <img
            class="right"
            v-if="pos_status.value[value.key].status == 0 && !pos_status.value[value.key].potvrda"
            src="../assets/images/Strelica_svetlo_zelena_desno.svg"
            alt
          />
          <img
            v-if="pos_status.value[value.key].potvrda && pos_status.value[value.key].status == 0"
            class="again"
            src="../assets/images/Stikla.svg"
            alt
          />
          <div v-if="pos_status.value[value.key].status == 1">
            <img class="again left" src="../assets/images/stikla_dupla.svg" alt />
          </div>
        </div>
      </div>
    </div>
    <div class="flex-spacer"></div>

    <div class="tab-footer">
      <div class="inner left" @click="routechange(1)">
        <span>
          {{ app_back }}
          <div class="arrow left">
            <img src="../assets/images/Strelica_Back.svg" alt="left" />
          </div>
        </span>
      </div>
      <div
        :class="['inner', 'right', get_all_knauf_positions_confirmed ? '' : 'disabled']"
        @click="get_all_knauf_positions_confirmed ? routechange(3) : show_info()"
      >
        <span>
          {{ app_next }}
          <div class="arrow right">
            <img src="../assets/images/Strelica_Next.svg" alt="left" />
          </div>
        </span>
      </div>
    </div>
    <div
      v-if="selected"
      id="pane_ver1"
      ref="rightpane"
      :class="{ 'intervention-overlay': true, left: left, 'windows-doors': get_position_type === 2 }"
    >
      <div class="main-header">
        <img src="../assets/images/KI logo.svg" alt="Logo" />
      </div>
      <!-- <div class="title" @click="navigate_back()">
        {{ get_ordered_construction[current.position].title }}
        
      </div> -->
      <div :class="{ 'existing-state': true, 'windows-doors': get_position_type === 2 }">
        <!-- <div class="arrow" @click="navigate_back(false)">
          <img src="../assets/images/Strelica_position_zelena_levo.svg" />
        </div> -->
        <div class="header existing">
          {{ pos_existing_title }}
        </div>
        <template v-if="get_position_type !== 2">
          <div class="hip-roof" v-if="pos_nagib.data.length && current.position == 7">
            <vue-checkbox
              :value="pos_nagib.value === 2"
              @input="value_change_new('pos_nagib', pos_nagib.value === 1 ? 2 : 1)"
              :class="{ 'vue-checkbox': true, green: pos_nagib.value === 2 }"
            >
            </vue-checkbox>
            <span>{{ pos_nagib.title }}</span>
          </div>
          <vue-carousel
            :name="'top_image'"
            :data_value="top.image"
            :data_array="filter_get_sklopovi_data"
            :images="app_sklopovi_a.images"
            :titles="app_sklopovi_a.title"
            :left_arrow="left_arrow"
            :right_arrow="right_arrow"
            :height="80"
            :strelice="true"
            :develop="develop"
            :small-height="30"
            :numbering="true"
            :default="top_image_default"
            class="correction-1 position"
            @carousel_change="value_change_new($event.name, $event.value)"
          ></vue-carousel>
          <div class="description top">{{ app_sklopovi_a.select[top.image] }}</div>
          <div
            v-if="get_sklopovi_data.debljina_zida[top.image] && get_sklopovi_data.debljina_zida[top.image].length > 1"
            class="regular"
          >
            <div class="left">
              <div class="circle">
                <div class="number">1</div>
              </div>
            </div>
            <div class="middle text">{{ pos_thickness_title }}</div>
            <div class="right">
              <!-- Odabir debljine zida -->
              <vue-select
                :design="{ color: '#b0d255' }"
                :data="{
                  data: get_sklopovi_data.debljina_zida[top.image],
                  value: top.debljina_zida,
                  text: get_sklopovi_data.debljina_zida[top.image],
                  isInteger: true,
                }"
                unit="cm"
                @vue-select-change="value_change_new('top_debljina_zida', $event)"
              ></vue-select>
            </div>
          </div>
          <div class="regular" v-if="app_sklopovi_a.data[top.image].ima_termoizolaciju">
            <div class="left">
              <div class="circle">
                <div class="number">
                  {{
                    get_sklopovi_data.debljina_zida[top.image] && get_sklopovi_data.debljina_zida[top.image].length > 1
                      ? 2
                      : 1
                  }}
                </div>
              </div>
            </div>
            <div class="middle text">{{ pos_current_insulation_title }}</div>
            <div class="right">
              <!-- Odabir debljine postojece izolacije -->
              <vue-select
                :design="{ color: '#b0d255' }"
                :data="{
                  data: Array(31)
                    .fill()
                    .map((x, i) => i)
                    .slice(1),
                  value: top.debljina_izolacije,
                  text: Array(31)
                    .fill()
                    .map((x, i) => i)
                    .slice(1),
                  isInteger: true,
                }"
                unit="cm"
                @vue-select-change="value_change_new('top_debljina_izolacije', $event)"
              ></vue-select>
            </div>
          </div>
        </template>
        <template v-else>
          <img v-if="current.position == 13" src="../assets/images/doorway.svg" alt="" class="watermark" />
          <img v-if="current.position == 10" src="../assets/images/windows.svg" alt="" class="watermark" />
          <div class="text-carousel">
            <div class="text-crousel-left">
              <img
                v-if="top.window_type != 0"
                src="../assets/images/Strelica_position_zelena_levo.svg"
                alt=""
                @click="arrow_click('top', 'left')"
              />
            </div>
            <div class="text-crousel-middle">
              {{ pos_window.select[top.window_type] }}
            </div>
            <div class="text-crousel-right">
              <img
                v-if="top.window_type != 2"
                src="../assets/images/Strelica_position_zelena_desno.svg"
                alt=""
                @click="arrow_click('top', 'right')"
              />
            </div>
          </div>
          <!-- Odabir vrste prozora ili vrata - trenutno stanje -->
          <vue-select
            class="door-window-select"
            :design="{ color: '#b0d255', left: true }"
            :data="{
              data: filter_top_windows,
              value: top.image,
              text: mapped_top_sklop_titles,
              isInteger: false,
            }"
            @vue-select-change="value_change_new('top_image', $event)"
          ></vue-select>
        </template>
        <div class="single-existing-padding"></div>
      </div>
      <div :class="{ 'new-state': true, 'windows-doors': get_position_type === 2 }">
        <div class="flex-header">
          <div class="header">
            {{ pos_intervention_title }}
          </div>
          <div class="onoff-cont">
            <vue-onoff
              :on="!!pos_status.value[current.position].status"
              @input="change_intervention_status()"
            ></vue-onoff>
          </div>
        </div>

        <div class="intervention-on">{{ pos_intervention_on_title }}</div>
        <div v-show="pos_status.value[current.position].status == 1">
          <template v-if="get_position_type !== 2">
            <!-- Ovaj div je prikazan samo kada je moguce postaviti izolaciju sa dve strane
                (iznad/ispod | unutra/spolja) => samo tada se vide tab titles -->
            <div class="mode" v-if="get_bottom_image_data.array.length > 1">
              <div
                :class="{ 'mode-left': true, active: bottom.image === 'b' }"
                @click="value_change_new('bottom_image', 'b')"
              >
                {{
                  current.position == 18
                    ? pos_above_title
                    : current.position == 19
                    ? pos_above_title
                    : pos_outside_title
                }}
              </div>
              <div
                :class="{ 'mode-right': true, active: bottom.image === 'c' }"
                @click="value_change_new('bottom_image', 'c')"
              >
                {{
                  current.position == 18 ? pos_below_title : current.position == 19 ? pos_below_title : pos_inside_title
                }}
              </div>
            </div>
            <div ref="image" class="image">
              <div>
                <img ref="imageA" v-if="bottom.image === 'b' && get_bottom_image_data.images.b" :src="get_bottom_image_data.images.b" alt />
                <img ref="imageB" v-else :src="get_bottom_image_data.images.c" alt />
              </div>
            </div>
            <div :class="['info-row', 'second', get_bottom_standard_title[2]]">
              {{ get_bottom_standard_title[0] }}
            </div>
            <div class="info-row third">
              {{ pos_insulation_title }}
            </div>
            <div class="info-row fourth">
              <div
                :class="['number', get_bottom_standard_title[2]]"
                :style="{
                  left:
                    bottom.debljina_izolacije.toFixed(0) == 0
                      ? '0'
                      : bottom.debljina_izolacije.toFixed(0) == 30
                      ? '100%'
                      : 'calc(100% / 30 * ' + bottom.debljina_izolacije.toFixed(0) + ')',
                }"
              >
                {{ bottom.debljina_izolacije.toFixed(0) }}
              </div>
            </div>
            <div class="regular slider">
              <div class="middle">
                <vue-slider
                  min="0"
                  max="30"
                  :value="bottom.debljina_izolacije"
                  @input="value_change_new('bottom_debljina_izolacije', $event)"
                  :index="get_standard_data_array"
                ></vue-slider>
              </div>
            </div>
            <div class="info-row fifth">
              <div class="left">U (W/m<sup>2</sup>K)</div>
              <div class="right">
                {{ app_math.numberWithCommas(get_pos_status_u[current.position].bottom.current) }}
              </div>
            </div>
            <div
              :class="{
                'info-row': true,
                sixth: true,
                red: get_bottom_standard_title[2] === 'red',
                'dark-green': get_bottom_standard_title[2] === 'dark-green',
              }"
            >
              {{ get_bottom_standard_title[3] }} (Umax {{ get_bottom_standard_title[2] === "red" ? "&gt;" : "&lt;=" }}
              {{ get_bottom_standard_title[1] }})
            </div>
            <div class="spacer">&nbsp;</div>
            <div class="description">
              <div v-if="bottom.image === 'b' && get_bottom_image_data.images.b">{{ get_bottom_image_data.titles.b }}</div>
              <div v-else>{{ get_bottom_image_data.titles.c }}</div>
            </div>
          </template>
          <template v-else>
            <div class="text-carousel bottom">
              <div class="text-crousel-left">
                <img
                  v-if="bottom.window_type != 0"
                  src="../assets/images/Strelica_position_zelena_levo.svg"
                  alt=""
                  @click="arrow_click('bottom', 'left')"
                />
              </div>
              <div class="text-crousel-middle">
                {{ pos_window.select[bottom.window_type] }}
              </div>
              <div class="text-crousel-right">
                <img
                  v-if="bottom.window_type != 2"
                  src="../assets/images/Strelica_position_zelena_desno.svg"
                  alt=""
                  @click="arrow_click('bottom', 'right')"
                />
              </div>
            </div>
            <!-- Odabir vrste prozora ili vrata nakon intervencije -->
            <vue-select
              class="door-window-select"
              :design="{ color: '#b0d255', left: true }"
              :data="{
                data: filter_bottom_windows,
                value: bottom.image,
                text: mapped_bottom_sklop_titles,
                isInteger: false,
              }"
              @vue-select-change="value_change_new('bottom_image', $event)"
            ></vue-select>
          </template>
        </div>
        <div class="confirm-line"></div>
        <div
          class="confirm-button"
          @click="navigate_back(true)"
          :style="{ 'background-color': pos_status.value[current.position].status == 1 ? '#b0d255' : '#82c964' }"
        >
          {{ pos_status.value[current.position].status == 1 ? pos_confirm_all_title : pos_confirm_title }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tab-container {
  overflow-x: hidden;
  background-color: $lighter_background;
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  .hidden-y {
    overflow-y: hidden;
  }

  .filter {
    filter: blur(5px);
  }
  .grey {
    color: $text_pos_light;
  }

  .green {
    color: $pos_back;
    font-weight: bold;
  }

  .intervention-overlay {
    position: fixed;
    top: 0;
    left: 100%;
    width: 100vw;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 10000;
    transition: left ease-out 0.3s;
    background-color: $lighter_background;
    display: flex;
    flex-direction: column;

    // &.windows-doors {
    //   background-color: $darker_background;

    //   .tab-footer {
    //     .inner.left {
    //       background-color: $darker_background;
    //     }
    //   }
    // }

    &.left {
      left: 0;
    }

    .main-header {
      flex: 0 0 calc(20vw * 1.0526);
      background: $main_header;
      display: flex;
      align-items: center;
      justify-content: center;

      @media screen and (max-width: 370px) {
        flex: 0 0 calc(20vw * 1.0526 * 0.85);
      }

      @media screen and (max-width: 320px) {
        flex: 0 0 calc(20vw * 1.0526 * 0.7);
      }

      img {
        width: 45%;
      }
    }

    .title {
      padding: 2rem 0 5.5rem 0;
      font-size: 2rem;
      letter-spacing: 0.5px;
      line-height: 1.3;
      text-align: center;
      color: $text_dark;
      position: relative;
    }

    .regular {
      height: 4.5rem;
      display: flex;
      align-items: center;

      &.slider {
        min-height: 1rem;
        height: auto;
        margin-bottom: 16px;
      }

      .left {
        flex: 0 0 15%;

        .circle {
          position: relative;
          height: 3.5rem;
          width: 3.5rem;
          background-color: $pos_back;
          border-radius: 50%;
        }

        .number {
          position: absolute;
          left: 50%;
          top: 50%;
          font-size: 2rem;
          line-height: 1.3;
          letter-spacing: 0.5px;
          color: $text_white;
          font-weight: bold;
          transform: translateX(-50%) translateY(-50%);
        }
      }

      .middle {
        flex: 1 0 1%;
        font-size: 1.6rem;
        line-height: 1.31;
        letter-spacing: 0.4px;
      }

      .right {
        height: 3.5rem;
        flex: 0 0 28.16%;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 1.17;
        letter-spacing: 0.5px;
      }

      .right.insulation {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 2.4rem;
        font-weight: bold;
        line-height: 1.29;
        letter-spacing: 0.6px;
        color: $pos_back;
      }
    }

    .description {
      font-size: 1.4rem;
      line-height: 1.31;
      letter-spacing: 0.4px;
      text-align: left;
      color: $text_semi_light;
      margin-bottom: 2.4rem;

      &.top {
        font-size: 1.5rem;
        padding-bottom: 1rem;
        text-align: center;
        min-height: 7rem;
        margin: 1.2rem auto 0 auto;
        width: 80%;
      }
    }

    .existing-state {
      flex: 0 0 auto;
      background-color: $darker_background;
      padding: 0 8.33%;
      position: relative;

      // &.windows-doors {
      //   background-color: $lighter_background;

      //   .arrow {
      //     background-color: $darker_background;
      //   }
      // }

      .hip-roof {
        display: flex;
        align-items: center;
        padding-top: 1rem;
        justify-content: center;

        .vue-checkbox {
          height: 20px;
          width: 20px;
          background-color: $text_white;
          border: 1px solid $text_pos_light;

          &.green {
            background-color: $pos_back;
            border: none;
          }
        }

        span {
          font-size: 1.6rem;
          line-height: 1.19;
          margin-left: 1rem;
        }
      }

      .arrow {
        position: absolute;
        left: 0;
        width: 5.4rem;
        top: 1rem;
        height: 5.4rem;
        background-color: $lighter_background;
        border-top-right-radius: 50%;
        border-bottom-right-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 1rem;
          margin-right: 0.3rem;
        }
      }

      .header {
        font-size: 2rem;
        line-height: 1.3;
        letter-spacing: 0.5px;
        text-align: center;
        color: $pos_back;
        padding: 2.4rem 0 0 0;
        font-family: "F-Dem";

        &.existing {
          color: #82c964;
        }
      }

      .existing-padding {
        padding-bottom: 8rem;
        border-bottom: 1px solid $text_dark;
      }

      .single-existing-padding {
        padding-bottom: 5rem;
      }

      .watermark {
        margin: 3.3rem auto 2.8rem auto;
        height: 20rem;
        max-height: 20rem;
        display: block;
      }
    }

    .new-state {
      select {
        display: block;
        width: 100%;
      }

      flex-grow: 1;
      background-color: $lighter_background;
      margin-top: -4rem;
      border-top-left-radius: 4rem;
      border-top-right-radius: 4rem;
      padding: 0 8.33%;
      position: relative;
      z-index: 1;

      // &.windows-doors {
      //   background-color: $darker_background;
      // }

      .flex-header {
        display: flex;
        align-items: center;
        padding: 2rem 0 1.3rem 0;

        .header {
          flex: 1 0 auto;
          font-size: 2rem;
          line-height: 1.3;
          letter-spacing: 0.5px;
          color: $pos_back;
          font-family: "F-Dem";
          font-weight: bold;
        }

        .onoff-cont {
          flex: 0 0 4rem;
        }
      }

      .intervention-on {
        font-size: 1.5rem;
        line-height: 1.2;
        color: $text_semi_light;
        margin-bottom: 2.4rem;
      }

      .mode {
        text-align: center;
        position: relative;
        display: flex;
        justify-content: space-between;

        div {
          flex: 0 0 49%;
          color: $text_light;
          border-bottom: 1px solid $text_light;
          text-align: center;
          padding: 0.5rem;
          font-size: 1.8rem;
          line-height: 1.33;
          cursor: pointer;

          &.active {
            font-family: F-Dem;
            color: $pos_back;
            border-bottom: 2px solid $pos_back;
            border-radius: 1px;
          }
        }
      }

      .image {
        img {
          width: 100%;
        }
      }

      .red {
        color: $calc_back;
      }

      .orange {
        color: $list_back;
      }

      .green {
        color: $pos_back;
      }

      .dark-green {
        color: $typ_back;
      }

      .info-row {
        &.second {
          text-align: center;
          margin-bottom: 1.2rem;
          font-family: F-Dem;
          font-size: 3.6rem;
          font-weight: bold;
        }

        &.third {
          text-align: center;
          margin-bottom: 1.2rem;
          font-size: 1.8rem;
          line-height: 1.11;
        }

        &.fourth {
          font-family: F-Dem;
          text-align: center;
          font-size: 3rem;
          font-weight: bold;
          margin: 0 9px 7rem 3px;
          position: relative;

          .number {
            position: absolute;
            top: 0;
            transform: translateX(-50%);
          }
        }

        &.fifth {
          margin-top: 2.5rem;
          margin-bottom: 1.5rem;
          font-size: 1.8rem;
          line-height: 1.11;
          display: flex;
          align-items: center;

          .left {
            text-align: left;
            flex-grow: 1;
          }

          .right {
            text-align: right;
            font-weight: bold;
          }
        }

        &.sixth {
          font-family: F-Dem;
          font-weight: bold;
          text-align: left;
          font-size: 1.4rem;
          margin-bottom: 1.2rem;
          line-height: 1.36;
        }
      }

      .spacer {
        height: 1rem;
      }

      .confirm-line {
        border-top: 1px solid $text_semi_light;
        margin-bottom: 2.8rem;
      }

      .confirm-button {
        border-radius: 3.5rem;
        font-size: 2.3rem;
        padding: 2.1rem 0;
        line-height: 1.17;
        text-align: center;
        color: $text_white;
        margin-bottom: 2.7rem;
      }
    }

    .text-carousel {
      display: flex;

      &.bottom {
        margin-top: 0.7rem;
      }

      .text-crousel-left {
        flex: 0 0 8%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      .text-crousel-middle {
        flex-grow: 1;
        font-family: F-Dem;
        font-size: 2.6rem;
        line-height: 1.15;
        text-align: center;
        color: $text_dark;
      }

      .text-crousel-right {
        flex: 0 0 8%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
    }

    .door-window-select {
      height: 3.5rem;
      text-align: left;
      margin-top: 2.1rem;
      margin-bottom: 3.4rem;
    }
  }

  .position-title {
    flex: 0 0 auto;
    font-size: 2rem;
    padding: 1.8rem 2rem 3.2rem 2rem;
    text-align: center;
    line-height: 2.6rem;
    color: $pos_back;
    font-family: "F-Dem";
    font-weight: bold;
  }

  .house-container-description {
    font-size: 1.8rem;
    line-height: 1.22;
    letter-spacing: normal;
    text-align: center;
    color: $text_dark;
    padding: 0 4rem 2.5rem 4rem;
  }

  .house-container {
    flex: 0 0 auto;
    margin: 0 auto 3.2rem auto;
    width: 83.33%;
  }

  .position-container {
    flex: 0 0 auto;
    width: 95%;
    margin-left: auto;
    margin-bottom: 0.8rem;
    height: 6rem;
    border-top-left-radius: 3rem;
    border-bottom-left-radius: 3rem;
    display: flex;

    .right {
      flex: 0 0 15%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      img.right {
        max-width: 1.3rem;
        height: auto;
        width: 1.3rem;
        margin-right: 1.8rem;
      }

      img.delete {
        width: 3rem;
        margin-right: 1rem;
      }

      img.again {
        width: 2.5rem;
        margin-right: 1rem;

        &.left {
          width: 4rem;
        }
      }
    }

    .middle {
      flex: 1 1 auto;
      justify-content: flex-start;
      align-items: center;
      text-align: left;
      display: flex;
      font-family: "F-Std";
      font-size: 1.8rem;
      letter-spacing: 0.5px;
      padding: 0 5%;
    }

    .left {
      margin-left: 5.2%;
      flex: 0 0 17%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .parameters {
    display: flex;
    align-items: baseline;
    justify-content: center;
    margin: 2rem auto 3rem auto;
    font-family: F-Std;
    font-size: 1.6rem;
    line-height: 1.13;
    letter-spacing: 0.4px;
    color: $pos_back;
    width: auto;

    .inner.right {
      margin-left: 1.5rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      svg {
        width: 1.4rem;
      }
    }
  }

  .additional {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease-out;
  }

  .flex-spacer {
    flex-grow: 1;
  }

  .tab-footer {
    flex: 0 0 auto;
    margin-top: 4.5rem;
    flex: 0 0 auto;

    .inner.right {
      background-color: $pos_back;

      &.disabled {
        background-color: $darker_background;
      }
    }

    &.special {
      .inner.right {
        border-top-left-radius: 0;
      }
    }
  }
}
</style>

<script>
import helpers from "../lib/helpers.js";
import app_math from "../lib/math.js";
import Slider from "../components/slider";
import Carousel from "../components/carousel";
import Select from "../components/select";
import Dialog from "../components/dialog";
import Hammer from "hammerjs";
import Checkbox from "../components/checkbox";
import OnOff from "../components/onoff";
import mixin from "../lib/mixins.js";
import superconsole from "../lib/superconsole.js";

export default {
  props: [
    "pos_define_positions_title",
    "get_loc_u_max",
    "pos_heading_title",
    "app_back",
    "app_next",
    "app_ok",
    "app_confirm",
    "app_proceed",
    "app_cancel",
    "pos_house",
    "typ_house",
    "typ_dubina",
    "typ_vrstatla",
    "typ_house_data",
    "typ_floornumber",
    "typ_floorarea",
    "typ_stanje",
    "pos_status",
    "pos_existing_title",
    "pos_intervention_title",
    "pos_thickness_title",
    "pos_insulation_title",
    "pos_current_insulation_title",
    "pos_inside_title",
    "pos_above_title",
    "pos_below_title",
    "pos_inside_description_title",
    "pos_outside_title",
    "pos_outside_description_title",
    "typ_select_house_title",
    "pos_confirm_title",
    "pos_confirm_all_title",
    "pos_intervention_on_title",
    "pos_description_title",
    "pos_nointervention_info_title",
    "pos_nagib",
    "pos_20_21",
    "pos_21_20_start",
    "pos_21_20_delete",
    "pos_standard",
    "pos_u_max_options_title",
    "pos_intervention_reset",
    "typ_constdate",
    "get_ordered_construction",
    "get_sklopovi_data",
    "app_sklopovi_a",
    "app_sklopovi_b",
    "app_sklopovi_c",
    "app_sklopovi",
    "app_tekuci_sklopovi",
    "app_sklopovi_default",
    "pos_u_value_options_title",
    "pos_u_value_low_title",
    "pos_u_value_good_title",
    "get_povrsine",
    "get_intervention_exists",
    "get_pos_status_u",
    "pos_window",
    "app_more_parameters_title",
    "app_less_parameters_title",
    "get_all_knauf_positions_confirmed",
    "get_knauf_intervention_exists",
    "develop",
    "typ_ceiling",
    "pos_position_select",
    "ga_gtag",
  ],
  mixins: [mixin],
  components: {
    "vue-slider": Slider,
    "vue-carousel": Carousel,
    "vue-select": Select,
    "vue-dialog": Dialog,
    "vue-checkbox": Checkbox,
    "vue-onoff": OnOff,
  },
  data: function () {
    return {
      app_math: app_math,
      confirm: null,
      current: {
        position: -1,
      },
      top: {
        image: "",
        debljina_zida: 0,
        debljina_izolacije: 0,
        debljina_izolacije_default: 0,
        window_type: 0,
      },
      bottom: {
        image: "",
        debljina_izolacije: 0,
        image_key: 1,
        window_type: 0,
      },
      promise: null,
      backup: {},
      prev_image: "",
      selected: false,
      left: false,
      rightpane: null,
      body: null,
      show_dialog: false,
      maincont: null,
      left_arrow: require("../assets/images/Strelica_position_zelena_levo.svg"),
      right_arrow: require("../assets/images/Strelica_position_zelena_desno.svg"),
      helpers: helpers,
      hammer: null,
      status: false,
      data_title: "",
      data_name: "",
      data_left: "",
      data_right: "",
      data_color: "",
      data_value: {},
    };
  },
  computed: {
    top_image_default: function () {
      if (this.typ_ceiling.value == 1) {
        return this.pos_status.value[this.current.position].top_image_default;
      } else {
        const def = this.pos_status.value[this.current.position].top_image_default;
        const splits = def.split("_");
        return "_" + splits[1] + "_" + (+splits[2] + 100);
      }
    },
    filter_get_sklopovi_data: function () {
      if (this.current.position != 18) {
        return this.get_sklopovi_data.sklopovi[this.current.position];
      } else {
        if (this.typ_ceiling.value == 1) {
          return this.get_sklopovi_data.sklopovi[this.current.position].filter((x) => x.split("_")[2] <= 100);
        } else {
          return this.get_sklopovi_data.sklopovi[this.current.position].filter((x) => x.split("_")[2] > 100);
        }
      }
    },
    get_ordered_construction_1: function () {
      return this.get_ordered_construction.filter((elem) => this.get_loop_position_type(elem.key) != 2);
    },
    get_ordered_construction_2: function () {
      return this.get_ordered_construction.filter((elem) => this.get_loop_position_type(elem.key) == 2);
    },
    get_bottom_standard_title: function () {
      let standard = 0;
      let iterator;
      for (iterator of this.get_standard_data_array) {
        const bvi = +this.bottom.debljina_izolacije;
        if ((bvi >= iterator[0] && bvi < iterator[1]) || (bvi === 30 && iterator[1] === 30)) {
          standard = iterator[3];
          break;
        }
      }
      return [
        standard === 0
          ? this.pos_u_value_low_title
          : standard === 1
          ? this.pos_u_value_good_title
          : this.pos_standard.select[standard - 1],
        iterator[2],
        iterator[4],
        standard === 0 ? this.pos_u_value_low_title : this.pos_u_value_good_title,
      ];
    },
    get_bottom_image_data: function () {
      let data = {};
      data.array = [];
      data.images = {};
      data.titles = {};
      if (this.app_sklopovi_b.images[this.top.image]) {
        data.array.push("b");
        data.images.b = this.app_sklopovi_b.images[this.top.image];
        data.titles.b = this.app_sklopovi_b.select[this.top.image];
      }
      if (this.app_sklopovi_c.images[this.top.image]) {
        data.array.push("c");
        data.images.c = this.app_sklopovi_c.images[this.top.image];
        data.titles.c = this.app_sklopovi_c.select[this.top.image];
      }
      return data;
    },
    get_position_type: function () {
      if (this.current.position == "10" || this.current.position == "13" || this.current.position == "60") {
        return 2;
      } else if (this.current.position == "20" || this.current.position == "21") {
        return 3;
      } else {
        return 1;
      }
    },
    get_calculate_bottom_debljina: function () {
      return app_math.get_calculate_bottom_debljina(
        this.current.position,
        this.pos_status,
        this.typ_dubina,
        this.typ_vrstatla,
        this.get_povrsine.povrsina_jednog_sprata,
        this.get_povrsine.duzina_strane_kuce,
        this.get_loc_u_max,
        this.get_position_type,
        this.app_sklopovi,
        this.get_sklopovi_data,
        this.top,
        this.get_top_sklop_data,
        this.bottom.window_type
      );
    },
    get_standard_data_array: function () {
      return app_math.get_standard_data_array(
        this.pos_standard,
        this.get_loc_u_max,
        this.current.position,
        this.pos_status,
        this.typ_dubina,
        this.typ_vrstatla,
        this.get_povrsine.povrsina_jednog_sprata,
        this.get_povrsine.duzina_strane_kuce,
        this.get_position_type,
        this.app_sklopovi,
        this.get_sklopovi_data,
        this.top,
        this.get_top_sklop_data,
        this.bottom.window_type
      );
    },
    get_top_sklop_data: function () {
      return helpers.get_top_sklop_data(
        this.app_sklopovi.data,
        this.top.image,
        this.top.debljina_zida,
        this.top.debljina_izolacije_default
      );
    },
    get_bottom_sklop_data: function () {
      return helpers.get_top_sklop_data(this.app_sklopovi.data, this.bottom.image);
    },
    filter_top_windows: function () {
      return this.get_sklopovi_data.sklopovi[this.current.position].filter(
        (elem) => helpers.get_top_sklop_data(this.app_sklopovi.data, elem).tip_prozora === this.top.window_type
      );
    },
    filter_bottom_windows: function () {
      return this.get_sklopovi_data.sklopovi[this.current.position].filter(
        (elem) => helpers.get_bottom_sklop_data(this.app_sklopovi.data, elem).tip_prozora === this.bottom.window_type
      );
    },
    mapped_top_sklop_titles: function () {
      const new_keys = {};
      if (this.get_position_type === 2) {
        for (const key of this.filter_top_windows) {
          new_keys[key] = this.app_sklopovi_a.title[key] + " (" + this.app_sklopovi.data[key].u + " W/m2K)";
        }
      }
      return new_keys;
    },
    mapped_bottom_sklop_titles: function () {
      const new_keys = {};
      if (this.get_position_type === 2) {
        for (const key of this.filter_bottom_windows) {
          new_keys[key] = this.app_sklopovi_a.title[key] + " (" + this.app_sklopovi.data[key].u + " W/m2K)";
        }
      }
      return new_keys;
    },
  },
  methods: {
    pre_approve: async function (name, value) {
      return new Promise((res) => {
        this.promise = res;
        this.dialogstart(name, value);
      });
    },
    dialogstart: async function () {
      const showDialog = (title) => {
        this.data_title = title;
        this.data_left = "";
        this.data_right = this.app_ok;
        this.data_value = {};
        this.data_name = "";
        this.show_dialog = true;
      };

      showDialog(this.pos_nointervention_info_title, "all");
    },
    dialogend: function (ev) {
      if (ev.confirm) {
        this.promise(true);
      } else {
        this.promise(false);
      }

      this.show_dialog = false;
    },
    value_change_new: function (name, value) {
      if (name === "pos_nagib") {
        this.valuechange("pos_nagib", value);
        this.set_values("bottom_debljina_izolacije", {});
      } else if (name === "top_image") {
        this.set_values("top_image", { image: value });
      } else if (name === "top_debljina_zida") {
        this.set_values("top_debljina_zida", { debljina_zida: value });
      } else if (name === "top_debljina_izolacije") {
        this.set_values("top_debljina_izolacije", { debljina_izolacije: value });
      } else if (name === "bottom_image") {
        this.set_values("bottom_image", { bottom_image: value });
      } else if (name === "bottom_debljina_izolacije") {
        this.set_values("bottom_debljina_izolacije", { bottom_debljina_izolacije: value });
      }
    },
    set_values: function (type, value) {
      if (type === "start") {
        const start = this.current.position;
        this.top.image = this.pos_status.value[start].top_image;
        this.top.debljina_zida = Math.round(this.pos_status.value[start].top_debljina_zida * 100);
        this.top.debljina_izolacije = Math.round(this.pos_status.value[start].top_debljina_izolacije * 100);
        this.top.debljina_izolacije_default = Math.round(
          this.pos_status.value[start].top_debljina_izolacije_default * 100
        );
        if (this.pos_status.value[start].status == 0) {
          // OTVARA SE PRVI PUT
          // POSTAVLJANJE TOP I BOTTOM WINDOW TYPE I ZATIM BOTTOM SLIKE
          this.top.window_type = this.get_top_sklop_data.tip_prozora;
          this.bottom.window_type = this.top.window_type;
          this.set_values("bottom_image", {});
          if (this.get_position_type !== 2) {
            // POSTAVLJANJE BOTTOM IZOLACIJE TIP 1 ILI 3
            this.set_values("bottom_debljina_izolacije", {});
          } else {
            // EMITOVANJE PODATAKA O SKLOPU - LAKA KONSTRUKCIJA, TIP PROZORA - TIP 2
            this.emit_sklop_data();
          }
        } else if (this.pos_status.value[start].status == 1) {
          // OTVARA SE PONOVO
          this.bottom.image = this.pos_status.value[start].bottom_image;
          this.bottom.debljina_izolacije = Math.round(this.pos_status.value[start].bottom_debljina_izolacije * 100);
          this.top.window_type = this.get_top_sklop_data.tip_prozora;
          this.bottom.window_type = this.get_bottom_sklop_data.tip_prozora;
        }
      } else if (type === "top_image") {
        this.top.image = value.image == null ? this.get_sklopovi_data.sklopovi[this.current.position][0] : value.image;
        this.emit_status("top_image", this.top.image);
        if (this.get_position_type !== 2) {
          // IDE SE DALJE U PODESAVANJA
          this.set_values("top_debljina_zida", value);
        } else {
          // POSTAVLJA SE BOTTOM SLIKA I KRAJ
          this.emit_sklop_data();
          if (this.pos_status.value[this.current.position].status != 1) {
            this.bottom.window_type = this.top.window_type;
          }
        }
        this.set_values("bottom_image", {});
      } else if (type === "top_debljina_zida") {
        this.top.debljina_zida =
          value.debljina_zida == null
            ? helpers.get_top_debljina_zida(this.get_sklopovi_data, this.top.image)
            : value.debljina_zida;
        this.emit_status("top_debljina_zida", app_math.round(this.top.debljina_zida / 100, 2));
        this.set_values("top_debljina_izolacije_default", value);
      } else if (type === "top_debljina_izolacije_default") {
        this.top.debljina_izolacije_default =
          value.debljina_izolacije_default == null
            ? helpers.get_top_debljina_izolacije(
                this.app_sklopovi_a.data,
                this.get_sklopovi_data,
                this.top.image,
                this.top.debljina_zida
              )
            : value.debljina_izolacije_default;
        this.emit_status(
          "top_debljina_izolacije_default",
          app_math.round(this.top.debljina_izolacije_default / 100, 2)
        );
        this.set_values("top_debljina_izolacije", {});
      } else if (type === "top_debljina_izolacije") {
        this.top.debljina_izolacije =
          value.debljina_izolacije == null ? this.top.debljina_izolacije_default : value.debljina_izolacije;
        this.emit_status("top_debljina_izolacije", app_math.round(this.top.debljina_izolacije / 100, 2));
        this.emit_sklop_data();
        this.set_values("bottom_debljina_izolacije", {});
      } else if (type === "bottom_image") {
        this.$nextTick(function () {
          this.bottom.image =
            value.bottom_image == null
              ? this.get_position_type !== 2
                ? +this.current.position === 7
                  ? this.app_sklopovi_c.select[this.top.image]
                    ? "c"
                    : "b"
                  : this.app_sklopovi_b.select[this.top.image]
                  ? "b"
                  : "c"
                : this.get_calculate_bottom_debljina.sklop
              : value.bottom_image;
          this.bottom.image_key = this.bottom.image_key === 1 ? 2 : 1;
          this.emit_status("bottom_image", this.bottom.image);
        });
      } else if (type === "bottom_debljina_izolacije") {
        this.$nextTick(function () {
          this.bottom.debljina_izolacije =
            value.bottom_debljina_izolacije == null
              ? app_math.get_izolacija(this.get_standard_data_array)
              : value.bottom_debljina_izolacije;
          this.emit_status("bottom_debljina_izolacije", app_math.round(this.bottom.debljina_izolacije / 100, 2));
        });
      }
    },
    change_intervention_status: function () {
      let path = "";
      const new_status = 1 - this.pos_status.value[this.current.position].status;
      if (new_status === 1) {
        path =
          `#/intervention/${this.current.position}/1 (mobile) | Position - Intervention / ` +
          this.pos_position_select[this.current.position] +
          " | (after intervention toggle on)";
      } else {
        path =
          `#/intervention/${this.current.position}/0 (mobile) | Position - Existing State / ` +
          this.pos_position_select[this.current.position] +
          " | (after intervention toggle off)";
      }
      superconsole.log(path);
      this.$router.push({ name: "intervention", params: { position: this.current.position, state: new_status } });
      if (typeof gtag !== "undefined") {
        // eslint-disable-next-line
        gtag("config", this.ga_gtag, {
          page_path: path,
        });
      }

      this.$emit("set_status_data", {
        value: this.current.position,
        status: new_status,
      });
    },
    emit_status: function (prop, value) {
      let event = { value: this.current.position };
      event[prop] = value;
      this.$emit("set_status_data", event);
    },
    emit_sklop_data: function () {
      const sklop = this.get_top_sklop_data;
      this.emit_status("laka_konstrukcija", sklop.laka_konstrukcija);
      this.emit_status("tip_prozora", sklop.tip_prozora);
    },
    routechange: function (index) {
      this.$emit("route_change", index);
    },
    valuechange: function (name, value, isnumber) {
      if (isnumber) {
        value = +value;
      }
      this.$emit("value_change", {
        name: name,
        value: value,
      });
    },
    navigate_right: async function (value) {
      const path = `#/intervention/${value}/0 (mobile) | Existing State - construction / ` + this.pos_position_select[value];
      superconsole.log(path);
      if (typeof gtag !== "undefined") {
        // eslint-disable-next-line
        gtag("config", this.ga_gtag, {
          page_path: path,
        });
      }
      this.$router.push({ name: "intervention", params: { position: value, state: 0 } });
    },
    get_save_data: function () {
      // todo nedostaje top_u i bottom_u
      const event = {};
      event.value = this.current.position;
      event.potvrda = true;
      // sve je vec je vec postavljeno
      return event;
    },
    navigate_back: function (confirm) {
      this.confirm = confirm;
      const path = `#/position (mobile) | Position List (after "Confirm..." tap)`;
      superconsole.log(path);
      if (typeof gtag !== "undefined") {
        // eslint-disable-next-line
        gtag("config", this.ga_gtag, {
          page_path: path,
        });
      }

      this.$router.push({ name: "position" });
    },
    overflowhidden: function () {
      this.body.classList.add("hidden-y");
      this.maincont.classList.add("hidden-y");
      this.$refs.rightpane.removeEventListener("transitionend", this.overflowhidden);
    },
    overflowhiddenend: function () {
      this.$refs.rightpane.removeEventListener("transitionend", this.overflowhiddenend);
      this.selected = false;
      this.current.position = -1;
    },
    toggleintervention: function () {
      if (this.get_bottom_image_data.array.length > 1) {
        this.value_change_new("bottom_image", this.bottom.image === "b" ? "c" : "b");
      }
    },
    arrow_click: function (position, direction) {
      let index = position === "top" ? this.top.window_type : this.bottom.window_type;
      if (direction === "left") {
        index--;
      } else {
        index++;
      }
      if (index == this.pos_window.data.length) {
        index = 0;
      } else if (index == -1) {
        index = this.pos_window.data.length - 1;
      }
      if (position === "top") {
        this.top.window_type = index;
        this.value_change_new("top_image", this.filter_top_windows[0]);
      } else {
        this.bottom.window_type = index;
        this.value_change_new("bottom_image", this.get_calculate_bottom_debljina.sklop);
      }
    },
    get_loop_position_type: function (position) {
      if (position == "10" || position == "13" || position == "60") {
        return 2;
      } else if (position == "20" || position == "21") {
        return 3;
      } else {
        return 1;
      }
    },
    toggle_position: function () {
      let elem = this.$refs["additional"];
      if (elem.style.maxHeight) {
        elem.style.maxHeight = null;
      } else {
        elem.style.maxHeight = elem.scrollHeight + "px";
      }
      if (this.status) {
        elem.addEventListener("transitionend", this.transitionend);
      } else {
        this.status = !this.status;
      }
    },
    transitionend: function (event) {
      this.status = !this.status;
      event.target.removeEventListener("transitionend", this.transitionend);
    },
    show_info: async function () {
      await this.pre_approve();
    },
  },
  beforeRouteEnter: function (to, from, next) {
    next(async (vm) => {
      if (to.name === "intervention") {
        vm.confirm = false;
        vm.current.position = to.params.position;
        vm.set_values("start");
        vm.selected = true;
        await vm.$nextTick();
        if (vm.get_position_type !== 2) {
          vm.hammer = new Hammer(vm.$refs.image);
          vm.hammer.on("swipeleft", vm.toggleintervention);
          vm.hammer.on("swiperight", vm.toggleintervention);
        }
        vm.$refs.rightpane.addEventListener("transitionend", vm.overflowhidden);
        window.setTimeout(function () {
          vm.left = true;
        }, 1);
      } else {
        if (vm.confirm != null) {
          vm.body.classList.remove("hidden-y");
          vm.maincont.classList.remove("hidden-y");
          if (vm.hammer) {
            vm.hammer.off("swipeleft");
            vm.hammer.off("swiperight");
            vm.hammer = null;
          }
          vm.$emit("set_status_data", vm.get_save_data());
          vm.confirm = null;
          vm.$refs.rightpane.addEventListener("transitionend", vm.overflowhiddenend);
          vm.left = false;
        }
      }
    });
  },
  mounted: function () {
    this.body = document.getElementsByTagName("body")[0];
    this.maincont = document.getElementById("main_container");
  },
  destroyed: function () {
    if (this.hammer) {
      this.hammer.off("swipeleft");
      this.hammer.off("swiperight");
      this.hammer = null;
    }
  },
};
</script>
